import { cloneDeep } from 'lodash-es';

export default {
  name: 'sanitizeDataFunctions',
  methods: {
    sanitizeData(path) {
      const self = this;
      const initialState = this.cs_editMode ? cloneDeep(this.$store.state.formData[path]) : {};

      return this.$store.subscribe((mutation) => {
        if (mutation.type === 'currentState/updateField' && mutation.payload
            && mutation.payload.path === 'navAction') {
          if (self.pu_usCitizen === 'No') {
            self.pu_ssn = '';
          }
        }
        if (mutation.payload && mutation.payload.path === 'navAction'
            && mutation.payload.value === 'previous' && this.cs_editMode) {
          this.setInstanceData('formData', initialState, `${path}.`);
        }
      });
    },
    sanitizeInstanceData(path) {
      const initialState = this.cs_editMode ? cloneDeep(this.$store.state.formData[path]) : {};
      return this.$store.subscribe((mutation) => {
        if (mutation.payload && mutation.payload.path === 'navAction'
            && mutation.payload.value === 'previous' && this.cs_editMode) {
          this.setInstanceData('formData', initialState, `${path}.`);
        }
      });
    },
  },
};
